import { useAnalysisOrder } from "../redux/ReduxContext";

export default function AnalysisOrderComment() {
    const { state, dispatch } = useAnalysisOrder();
    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 drop-shadow-md dark:drop-shadow-none mb-4 text-primary-dark dark:text-primary-light">
            <h6 className="mb-2 text-sm font-bold">Comment</h6>
            <textarea
                className="resize-y border w-full p-2 mt-2 pt-3 text-sm focus:outline-none focus:ring-2 bg-primary-light dark:bg-oi-dark-background border-primary-dark/70 dark:border-primary-light/50 text-primary-dark dark:text-oi-powder-form-yellow placeholder-gray-400 dark:placeholder-gray-300 min-h-12 overflow-hidden"
                placeholder="Add additional comments here..."
                rows={1}
                value={state.comment}
                onChange={(e) => {
                    dispatch({ type: 'SET_FIELD', payload: { field: 'comment', value: e.target.value } });
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                }}
            />
        </div>
    );
}
